import { TweenMax, Power4 } from "gsap/all";

import VLDForm from "./VLD.Form";

class VLDFormRequest extends VLDForm {
  public onResponseSuccess(res) {
    const duration = 1.2;
    const $success = this.$form.querySelector("[data-success]");
    const $successIcon = this.$form.querySelector("[data-success-icon]");
    const $successCheck = this.$form.querySelector("[data-success-check]");
    const $formContent = this.$form.querySelector("[data-form-content]");
    $success.style.display = "block";
    $formContent.style.display = "none";

    const title: HTMLElement = (this
      .$form as HTMLElement).parentElement.querySelector(".modal__title");

    title.style.opacity = "0";

    TweenMax.fromTo(
      $success,
      duration,
      {
        y: 120,
        opacity: 0,
        ease: Power4.easeOut
      },
      {
        y: 0,
        opacity: 1,
        ease: Power4.easeOut
      }
    );
    TweenMax.fromTo(
      $successIcon,
      duration,
      {
        rotation: -45,
        opacity: 0,
        scale: 0.6,
        ease: Power4.easeOut
      },
      {
        rotation: 0,
        opacity: 1,
        scale: 1,
        ease: Power4.easeOut
      }
    ).delay(duration * 0.3);
    TweenMax.fromTo(
      $successCheck,
      duration,
      {
        rotation: 0,
        opacity: 0,
        scale: 0.6,
        ease: Power4.easeOut
      },
      {
        rotation: 45,
        opacity: 1,
        scale: 1,
        ease: Power4.easeOut
      }
    ).delay(duration * 0.6);
    this.$form.classList.add(res === "success" ? "has-success" : "has-error");
  }
}

export default VLDFormRequest;
